import React, {Component} from 'react';
import '../assets/teachers.css';
import logo from '../assets/images/logo_avenuepm.png';
import REST from "./REST";
import {
    selectClass,
    selectStudentScoreListTab,
    selectStudentTab,
    updateStudent,
    userLogout
} from "../TeachersComponent/actions";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';

const DropDownNotifications = class DropDownNotificationsComponent extends Component {

    constructor(props) {
        super(props);

        this.toggleOpenFirst = this.toggleOpenFirst.bind(this);
        this.handleTasksClick = this.handleTasksClick.bind(this);

        this.state = {
            isOpen: false,
            totalTasks: 0,
            notifications: [],
        }
    }

    componentDidMount() {
        REST.getStudentNotifications().then(res => {
            let totalTasks = 0;
            for (let not of res.body) {
                totalTasks = totalTasks
                    + not.apps.kidSignScores.length
                    + not.apps.kidSpeakScores.length
                    + not.apps.wordMarkScores.length
                    + not.apps.copyRightScores.length
                    + not.apps.pictureNamingScores.length
                    + not.apps.wordSignSayScores.length
            }
            this.setState({
                notifications: res.body,
                totalTasks: totalTasks
            });
        });
    }

    async handleTasksClick(notification,scoreTaskTab,e){
        e.preventDefault();
        let theClass = notification.student.classes.filter((v)=>{return v.classes_student.active});
        if(theClass.length>0){
            theClass = theClass[0];
        }else{
            theClass = null;
        }
        await this.props.selectStudentTab(3); //3 is score list tab
        await this.props.selectStudentScoreListTab(scoreTaskTab);
        await this.props.studentClick(notification.student,theClass);
    }

    toggleOpenFirst(e) {
        this.setState({
            isOpen: !this.state.isOpen
        });
        e.preventDefault();
    }


    render() {
        const menuClass = this.state.isOpen ? " open" : "";

        const notificationBlocks = this.state.notifications.map((not, index) => {
            return (
                <li key={index} style={{width:"100%"}}>
                    <div className="row noMarginLR">
                        <div className={"col-md-4"}>
                            <p>{not.student.user.firstname} {not.student.user.lastname}</p>
                        </div>
                        <div className={"col-md-8"}>
                            <ul className={"list-group"}>
                                {
                                    not.apps.copyRightScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,4,e)}
                                        >
                                            CopyRight Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.copyRightScores.length}</span>
                                        </li>

                                        : null
                                }
                                {
                                    not.apps.kidSignScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,6,e)}
                                        >
                                            KidSign Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.kidSignScores.length}</span>
                                        </li>

                                        : null
                                }
                                {
                                    not.apps.kidSpeakScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,2,e)}
                                        >
                                            KidSpeak Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.kidSpeakScores.length}</span>
                                        </li>

                                        : null
                                }
                                {
                                    not.apps.pictureNamingScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,3,e)}
                                        >
                                            PictureNaming Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.pictureNamingScores.length}</span>
                                        </li>

                                        : null
                                }
                                {
                                    not.apps.wordMarkScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,1,e)}
                                        >
                                            WordMark Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.wordMarkScores.length}</span>
                                        </li>

                                        : null
                                }
                                {
                                    not.apps.wordSignSayScores.length > 0 ?

                                        <li style={{width: "100%",cursor:"pointer"}}
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            onClick={(e) => this.handleTasksClick(not,5,e)}
                                        >
                                            Word Sign/Say Tasks
                                            <span className="badge badge-primary badge-pill">{not.apps.wordSignSayScores.length}</span>
                                        </li>

                                        : null
                                }
                            </ul>
                        </div>
                    </div>
                    <hr style={{width: "100%"}}/>
                </li>
            )
        });
        return (
            <ul className="nav navbar-nav pull-right">
                <li className={"dropdown" + menuClass} style={{marginTop:1}}>
                    <a className={this.state.notifications.length>0 ? "dropdown-toggle handBtn notificationsOn" : "dropdown-toggle handBtn"} data-toggle="dropdown" role="button" aria-haspopup="true"
                       aria-expanded="false"
                       onClick={this.toggleOpenFirst}><span>To Do List (<b>{this.state.totalTasks}</b>)</span></a>
                    <div className="dropdown-menu notify-drop">
                        <div className="notify-drop-title">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">Unscored Tasks
                                </div>
                            </div>
                        </div>
                        <div className="drop-content">
                            {notificationBlocks}
                        </div>
                        <div className="notify-drop-footer text-center">
                            <a onClick={() => this.setState({isOpen: false})}>Close</a>
                        </div>
                    </div>
                </li>
            </ul>
        )
    }
};

const bindActionToProps = dispatch => {
    return {
        selectStudentTab:async(selectedTab) => await dispatch(selectStudentTab(selectedTab)),
        selectStudentScoreListTab:async(selectedScoreListTab) => await dispatch(selectStudentScoreListTab(selectedScoreListTab)),
    };
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, bindActionToProps)(DropDownNotifications)
